{
  "title": "How to Check Your Pre-Launch Readiness",
  "description": "Use the \"Readiness\" checklist on the competition overview page to see what setup is still outstanding before launch.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you can clearly see which setup items for this competition still aren't ready, and finish them one by one before confidently opening it to participants.",
  "roleNote": "Competition Admin",
  "prerequisites": ["You have admin access to this competition"],
  "pathLabel": "Organizer Console → Competition Overview → Readiness",
  "steps": [
    {
      "title": "1. Open the competition overview page",
      "description": "Go to this competition's overview page — the \"Readiness\" card is computed live from your current actual settings, not a fixed static checklist."
    },
    {
      "title": "2. Check the \"Action Needed\" list",
      "description": "By default it only shows items that aren't ready yet, out of 9 possible: Basic Information, Schedule, Eligibility, Categories, Dynamic Form, Rubric, Judging Setup, Public Page, Publish."
    },
    {
      "title": "3. Click an item to jump straight to its settings",
      "description": "\"Categories\", \"Dynamic Form\", \"Rubric\", and \"Judging Setup\" link directly to their respective settings tab; once each is finished, it drops off the \"Action Needed\" list."
    },
    {
      "title": "4. Expand the full list to see overall progress",
      "description": "Expand the summary (which shows \"N / 9 complete\") to see the full list including already-ready items, for an overall progress view."
    }
  ],
  "afterward": [
    "Once every item shows \"Ready\", the Action Needed list shows \"There's nothing that needs immediate attention right now\"",
    "This list is computed live — any settings change (e.g. adding a category, publishing a form) is reflected on the list immediately, with no manual refresh or recalculation needed"
  ],
  "nextSteps": "Once everything on the checklist is ready, you can move the competition's status from Draft to Published to officially open it.",
  "faq": [
    {
      "q": "What makes the \"Categories\" item show as ready?",
      "a": "It shows ready as soon as this competition has at least one category record, even if that category has since been archived (this item currently only checks \"has one ever been created\", not whether it's still active); see \"How to Configure Competition Categories\"."
    },
    {
      "q": "What do \"Dynamic Form\" and \"Rubric\" correspond to?",
      "a": "\"Dynamic Form\" tracks whether at least one form has had a version published (see \"How to Build and Publish Forms\"); \"Rubric\" tracks whether at least one rubric has been created (see \"How to Create a Rubric\")."
    },
    {
      "q": "Can an item get permanently stuck on \"Not Started\"?",
      "a": "No, it can't get stuck for no reason — every item is computed live from your current actual data. If an item keeps showing \"Not Started\", the corresponding setup (e.g. schedule's registration/submission start times, judging setup's judge count) genuinely hasn't been completed yet — follow the link next to it to finish that setup."
    },
    {
      "q": "Where does the \"Contact email\" at the end of announcement and reminder emails come from?",
      "a": "It comes from the \"Contact email\" field in the Settings card on the competition Overview page; when it is empty, announcement emails, registration-update reminders and registration reminders omit that line. Before launch, make sure it is the address participants should write to."
    }
  ]
}
